import { ALLOWED } from "@/app/infrastructures/misc/RolePermission";
import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";
const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");
const ShipmentBooking = () =>
  import(
    /* webpackChunkName: "STTBooking" */ "@/app/ui/views/shipment/booking/index.vue"
  );
const TabBooking = () =>
  import(
    /* webpackChunkName: "STTBookingList" */ "@/app/ui/views/shipment/booking/tab-booking/tab-list-booking.vue"
  );
const TabBookingClientCBP = () =>
  import(
    /* webpackChunkName: "STTBookingClientCBP" */ "@/app/ui/views/shipment/booking/tab-booking/tab-list-booking-client-cbp.vue"
  );
const DetailBooking = () =>
  import(
    /* webpackChunkName: "STTBooking" */ "@/app/ui/views/shipment/booking/detail-booking/detail.vue"
  );
const CreateBooking = () =>
  import(
    /* webpackChunkName: "STTBooking" */ "@/app/ui/views/shipment/booking/config-create-booking/index.vue"
  );
const CreateBookingShipment = () =>
  import(
    /* webpackChunkName: "STTBooking" */ "@/app/ui/views/shipment/booking/config-create-booking-shipment/index.vue"
  );
const EditBooking = () =>
  import(
    /* webpackChunkName: "STTBooking" */ "@/app/ui/views/shipment/booking/config-edit-booking/index.vue"
  );
const InstantBookingShipmentV2 = () =>
  import(
    /* webpackChunkName: "InstantBooking" */ "@/app/ui/views/shipment/booking/instant-booking-v2/index.vue"
  );
const CreateBookingV3 = () =>
  import(
    /* webpackChunkName: "CreateBookingV3" */ `@/app/ui/views/shipment/booking/create-booking-v3/create-booking-manual.vue`
  );
const CreateBookingClientV3 = () =>
  import(
    /* webpackChunkName: "CreateBookingV3" */ `@/app/ui/views/shipment/booking/create-booking-v3/create-booking-client.vue`
  );
const EditBookingV3 = () =>
  import(
    /* webpackChunkName: "InstantBooking" */ "@/app/ui/views/shipment/booking/create-booking-v3/edit-booking.vue"
  );
const EditBookingV4 = () =>
  import(
    /* webpackChunkName: "EditBookingV4" */ "@/app/ui/views/shipment/booking/create-booking-v4/edit-booking.vue"
  );

const maskedPath = new Date().getTime() + Math.random() + "";

export default [
  {
    path: "/booking",
    name: "booking-layout",
    component: Layout,
    meta: {
      icon: "booking",
      children: false,
      header: true,
      title: "Booking",
      name: "Booking",
      maskedPath: maskedPath,
      gtmEventName: "shipment_menu_clicked",
      gtmEventCustoms: {},
      gtmEventOption: ["userType", "timestamp", "userId"],
      permission: FlagsPermissionBooking.permission_booking_enable
    },
    children: [
      {
        path: "",
        name: "booking",
        component: ShipmentBooking,
        redirect: "/booking/booking-list",
        meta: {
          header: true,
          icon: "booking",
          title: "Booking",
          name: "Booking",
          maskedPath: maskedPath,
          gtmEventName: "booking_submenu_clicked",
          gtmEventCustoms: {},
          gtmEventOption: ["userType", "timestamp", "userId"],
          permission: FlagsPermissionBooking.permission_booking_view_list
        },
        children: [
          {
            path: "booking-list",
            name: "booking-list",
            component: TabBooking,
            meta: {
              tab: "booking-list",
              maskedPath: maskedPath,
              permission: FlagsPermissionBooking.permission_booking_view_list
            }
          },
          {
            path: "booking-client-cbp-list",
            name: "booking-client-cbp-list",
            component: TabBookingClientCBP,
            meta: {
              tab: "booking-client-cbp-list",
              maskedPath: maskedPath
            }
          }
        ]
      }
    ]
  },
  {
    path: "/booking",
    component: Layout,
    name: "booking-detail",
    meta: {
      title: "Booking | Detail",
      hidden: true,
      parent: "Booking",
      maskedPath,
      permission: FlagsPermissionBooking.permission_booking_view_detail
    },
    children: [
      {
        path: ":id",
        name: "detail-booking-v1",
        component: DetailBooking,
        meta: {
          header: true,
          isAuth: true,
          maskedPath,
          bookingPath: "/booking"
        }
      }
    ]
  },
  {
    path: "/booking",
    component: Layout,
    name: "create-booking-stt",
    meta: {
      icon: "create-booking",
      hidden: true,
      parent: "Booking",
      maskedPath,
      permission: FlagsPermissionBooking.permission_booking_create_manual
    },
    children: [
      {
        path: "create",
        name: "create-booking-stt",
        component: CreateBooking,
        meta: {
          header: true,
          title: "Booking | Create ",
          name: "Buat Booking Baru",
          before: "/booking",
          formType: "manual",
          maskedPath,
          validateAccount: true
        }
      }
    ]
  },
  {
    path: "/booking",
    component: Layout,
    name: "create-booking-stt-client",
    meta: {
      icon: "create-booking",
      hidden: true,
      parent: "Booking",
      maskedPath,
      permission: FlagsPermissionBooking.permission_booking_create_for_corporate
    },
    children: [
      {
        path: "create-client",
        name: "create-booking-stt-client",
        component: CreateBooking,
        meta: {
          header: true,
          title: "Booking | Create ",
          name: "Buat Booking Baru",
          before: "/booking",
          formType: "client",
          maskedPath,
          validateAccount: true
        }
      }
    ]
  },
  {
    path: "/booking",
    component: Layout,
    name: "create-booking-stt-by-shipment-id",
    meta: {
      icon: "create-booking",
      hidden: true,
      parent: "Booking",
      maskedPath,
      permission: FlagsPermissionBooking.permission_booking_create_shipment_id
    },
    children: [
      {
        path: "create/by-shipment-id",
        name: "create-booking-stt-by-shipment-id",
        component: CreateBookingShipment,
        meta: {
          header: true,
          title: "Booking | Apps Booking",
          name: "Booking aplikasi & marketplace",
          before: "/booking",
          maskedPath,
          validateAccount: true
        }
      }
    ]
  },
  {
    path: "/booking",
    component: Layout,
    name: "create-instant-booking-shipment",
    meta: {
      icon: "create-booking",
      hidden: true,
      parent: "Booking",
      maskedPath,
      permission: FlagsPermissionBooking.permission_instant_booking_create
    },
    children: [
      {
        path: "create/instant-booking-shipment",
        name: "create-instant-booking-shipment",
        component: InstantBookingShipmentV2,
        meta: {
          header: true,
          title: "Booking | Instant Shipment Booking",
          name: "Booking Instant Shipment",
          before: "/booking",
          maskedPath,
          validateAccount: true
        }
      }
    ]
  },
  {
    path: "/booking",
    component: Layout,
    name: "booking-edit",
    meta: {
      title: "Booking | Edit",
      hidden: true,
      icon: "booking",
      parent: "Booking",
      permission: FlagsPermissionBooking.permission_booking_edit,
      maskedPath
    },
    children: [
      {
        path: ":id/edit",
        name: "edit-booking",
        component: EditBooking,
        meta: {
          header: true,
          title: "Booking | Edit",
          name: "Ubah Booking",
          before: "/booking/:id",
          isAuth: true,
          bookingPath: "/booking",
          maskedPath
        }
      }
    ]
  },
  {
    path: "/booking",
    name: "booking-v1-create-retail",
    component: Layout,
    meta: {
      hidden: true,
      icon: "booking",
      permission: ALLOWED,
      maskedPath: maskedPath,
      parent: "Booking"
    },
    children: [
      {
        path: "create-v3",
        name: "shipment-booking-v3-create",
        component: CreateBookingV3,
        meta: {
          header: true,
          name: "Booking baru",
          title: "Booking baru",
          before: "/booking",
          maskedPath
        }
      }
    ]
  },
  {
    path: "/booking",
    name: "booking-v3-create-client",
    component: Layout,
    meta: {
      hidden: true,
      icon: "booking",
      permission: ALLOWED,
      maskedPath: maskedPath,
      parent: "Booking"
    },
    children: [
      {
        path: "create-client-v3",
        name: "booking-v3-create-client",
        component: CreateBookingClientV3,
        meta: {
          header: true,
          name: "Booking baru",
          title: "Booking baru",
          maskedPath,
          before: "/booking"
        }
      }
    ]
  },
  {
    path: "/booking",
    component: Layout,
    name: "booking-edit-v3",
    meta: {
      title: "Booking | Edit",
      hidden: true,
      icon: "booking",
      parent: "Booking",
      permission: FlagsPermissionBooking.permission_booking_edit,
      maskedPath
    },
    children: [
      {
        path: ":id/edit-v3",
        name: "shipment-booking-v3-edit",
        component: EditBookingV3,
        meta: {
          header: true,
          title: "Booking | Edit",
          name: "Ubah Booking",
          before: "/booking/:id",
          bookingPath: "/booking",
          isAuth: true,
          maskedPath
        }
      }
    ]
  },
  {
    path: "/booking",
    component: Layout,
    name: "booking-edit-v4",
    meta: {
      title: "Booking | Edit",
      hidden: true,
      icon: "booking",
      parent: "Booking",
      permission: FlagsPermissionBooking.permission_booking_edit,
      maskedPath
    },
    children: [
      {
        path: ":id/edit-v4",
        name: "shipment-booking-v4-edit",
        component: EditBookingV4,
        meta: {
          header: true,
          title: "Booking | Edit",
          name: "Ubah Booking",
          before: "/booking/:id",
          bookingPath: "/booking",
          isAuth: true,
          maskedPath
        }
      }
    ]
  }
];
